"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwipeIcon = exports.Chevron = exports.CarouselBody = exports.CarouselWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
// ideally remove icon dependency
const core_basis_bs_icon_1 = require("@hotelplan/core.basis.bs-icon");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
exports.CarouselWrapper = styled_components_1.default.div(({ isOverlay: isOverlay, theme }) => isOverlay
    ? theme.responsiveMediaGallery.carouselWrapper.overlay
    : theme.responsiveMediaGallery.carouselWrapper.preview);
exports.CarouselBody = styled_components_1.default.div(({ theme }) => theme.responsiveMediaGallery.carouselBody);
exports.Chevron = (0, styled_components_1.default)(core_basis_bs_icon_1.BsIcon)(({ theme }) => theme.responsiveMediaGallery.chevron, ({ enable }) => (enable ? { display: 'block' } : null));
exports.SwipeIcon = (0, styled_components_1.default)(core_basis_bs_icon_1.BsIcon).attrs({
    name: 'swipe',
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    display: ['inline-block', 'inline-block', 'none'],
    zIndex: 2,
    height: '50px',
    width: '50px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    pointerEvents: 'none',
}));
//# sourceMappingURL=gallery-slider.styles.js.map